/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

const defaults: vp.AccountBrandingResponse = {
  Success: false,
  ErrorMessage: '',
  BrandingDetails: {
    PrimaryColor: '#FFD147',
    SecondaryColor: '',
  },
  Logo: '',
  SmallLogo: '',
  Favicon: '',
  AppTitle: '',
};

type ReturnTuple = [vp.AccountBrandingResponse, (requestParams: vp.AccountBrandingRequest) => void, () => void];
function useFetchAccountBranding({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const { t } = useTranslation('translations', { keyPrefix: 'Common' });
  const [params, setParams] = useState<vp.AccountBrandingRequest>();
  const [response, setResponse] = useState<vp.AccountBrandingResponse>(defaults);
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.AccountBrandingRequest) => {
      setDataFetchingInfo(true, `${t('defaultLoading')}`, 'fullScreen');
      const res = await api.fetchAccountBranding(requestParams, source);
      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);
      return () => {};
    };
    if (params && shouldSendRequest) void sendRequest(params);
    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.AccountBrandingRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(defaults);
      setSendRequest(false);
    },
  ];
}
export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchAccountBranding);
